import { render } from "./AssociationContact.vue?vue&type=template&id=08a818e2"
import script from "./AssociationContact.vue?vue&type=script&lang=js"
export * from "./AssociationContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__